import { NotFound } from 'app/pages/notFound/NotFound';
import { useManagedDepartmentsQuery } from 'lib/api/departments/useManagedDepartmentsQuery';
import { useGetLinkSetsQuery } from 'lib/api/exitLinkSets/getExitLinksSets';
import { useGetOverlays } from 'lib/api/overlays/getOverlaysQuery';
import { useGetTemplatesQuery } from 'lib/api/templates/getTemplatesQuery';
import { useManagedUsersQuery } from 'lib/api/users/useManagedUsersQuery';
import { useUserProfileQuery } from 'lib/api/users/useUsersProfileQuery';
import { LoadingIndicator } from 'lib/components';
import { Container, MainWrapper } from 'lib/components/styles/layout';
import { useAuth } from 'lib/context';
import React from 'react';
import { useParams } from 'react-router-dom';
import { AddonsTab } from './AddonsTab';
import { UserInfoTab } from './UserInfoTab';
import { TabGroup } from 'lib/components/tabs/TabGroup';
import { useTabFromQueryString } from 'lib/components/tabs/useTabFromQueryString';
import { useTranslation } from 'react-i18next';

export const ManageUserEntryPage = () => {
  const { t } = useTranslation();
  const tabItems = [
    {
      title: t('User Info'),
      value: 'user_info',
    },
    {
      title: t('Add-ons'),
      value: 'add_ons',
    },
  ];
  const { activeTab } = useTabFromQueryString({
    defaultValue: tabItems[0].value,
  });
  const {
    userData: { customerId },
  } = useAuth();

  const { data, isLoading: isLoadingManagedUsers } = useManagedUsersQuery({
    customerId,
  });

  const { id } = useParams() as { id: string | undefined };

  const { data: departments, isLoading: isLoadingDepartments } =
    useManagedDepartmentsQuery({ customerId });

  const { data: templates, isLoading: isLoadingTemplates } =
    useGetTemplatesQuery({
      limit: 1000,
      showUserCustomLandingPages: false,
    });

  const { data: websiteOverlays, isLoading: isLoadingWebsiteOverlays } =
    useGetOverlays({});

  const { data: linksetsData } = useGetLinkSetsQuery({ limit: 1000 });
  const { data: currentUser, isLoading } = useUserProfileQuery({
    userId: id ? id : '',
  });

  if (
    isLoading ||
    isLoadingTemplates ||
    isLoadingWebsiteOverlays ||
    isLoadingDepartments ||
    isLoadingManagedUsers
  ) {
    return <LoadingIndicator isLoading={true} />;
  }

  if (!currentUser && !!id) {
    return <NotFound />;
  }

  const isExceeded =
    (data?.totalActiveUsers ?? 0) >= (data?.totalAllowedUsers ?? 0);

  return (
    <Container>
      <MainWrapper resetPadding={false}>
        {activeTab === tabItems[0].value && (
          <UserInfoTab
            currentUser={currentUser}
            departments={departments}
            templates={templates}
            websiteOverlays={websiteOverlays}
            linksetsData={linksetsData}
            isExceeded={isExceeded}
          >
            {!!id ? <TabGroup items={tabItems} /> : <></>}
          </UserInfoTab>
        )}

        {activeTab === tabItems[1].value && (
          <AddonsTab currentUser={currentUser}>
            {!!id ? <TabGroup items={tabItems} /> : <></>}
          </AddonsTab>
        )}
      </MainWrapper>
    </Container>
  );
};
